/**
 * カートの行を注文 API に送る形へ直す。
 *
 * 注文を送る口は 4 つある (卓のセルフオーダー / 先払いのテイクアウト / レジ受付 / 出前)。
 * 以前はそれぞれが同じ 5 項目を手で並べており、#2031 で項目が増えたときに
 * **1 つでも足し忘れると、その経路だけ選択が厨房に届かない**ので 1 か所にまとめた。
 */
import type { CartItem } from '../store/useStore'
import type { VariationSelection } from './menuVariation'

export interface OrderItemPayload {
  menuItemId: string
  name: string
  nameEn: string
  price: number
  quantity: number
  /** #2031 客が選んだバリエーション。サーバが店の定義と突き合わせて検算する。 */
  selectedVariations?: VariationSelection
}

export function toOrderItems(items: CartItem[]): OrderItemPayload[] {
  return items.map((i) => ({
    menuItemId: i.menuItemId,
    name: i.name,
    // サーバの CartItem で nameEn は**必須**。undefined を送ると注文が丸ごと 422 で落ちる
    // (#1353)。英名を持たない品は正当に存在するので、境界で '' に倒す。
    nameEn: i.nameEn ?? '',
    // #2031 **本体だけを送る。** カートの price は 本体 + 追加 (客に見せる値段) だが、追加は
    // サーバが店の定義から足す。追加込みで送ると二重に請求される。
    price: i.price - (i.optionsPrice ?? 0),
    quantity: i.quantity,
    ...(i.selectedVariations ? { selectedVariations: i.selectedVariations } : {}),
  }))
}
